import React from "react";
import ButtonWithIcon from "../../components/ButtonwithIcon/ButtonWithIcon";

// The cart of products added to the enquiry being created/edited, with
// per-item pricing, tax, quantity controls and the topics/actions editor.
const SelectedProductsCart = ({
  enquiryForm,
  updateProductQuantity,
  removeProductFromCart,
  updateProductPrice,
  updateProductTaxRate,
  addTopicToProduct,
  updateTopic,
  removeTopic,
  addActionToTopic,
  updateAction,
  removeAction,
}) => {
  return (
                  <div className="selected-products-cart">
                    <div className="cart-header">
                      <h4>Selected Products ({enquiryForm.products.length})</h4>
                    </div>

                    {enquiryForm.products.length > 0 ? (
                      <div className="cart-items">
                        {enquiryForm.products.map((product, index) => (
                          <div key={index} className="cart-item">
                            <div className="cart-item-header">
                              <span className="product-name">
                                {product._displayInfo?.productName || "Product"}
                              </span>
                              <ButtonWithIcon
                                icon="mdi:delete"
                                text=""
                                onClick={() => removeProductFromCart(index)}
                                className="cancel-button btn-icon-only"
                                type="button"
                              />
                            </div>

                            <div className="cart-item-specs">
                              {product._displayInfo?.specs?.map((spec, idx) => (
                                <span key={idx} className="spec-tag">
                                  {spec.specificationName}: {spec.value}
                                </span>
                              ))}
                            </div>

                            <div className="cart-item-details">
                              <div className="cart-pricing-breakdown">
                                <div className="pricing-row selling-price-row">
                                  <span className="pricing-label">
                                    Selling Price:
                                  </span>
                                  <span className="pricing-value bold">
                                    ₹
                                    {(
                                      product._displayInfo?.sellingPrice || 0
                                    ).toFixed(2)}
                                  </span>
                                </div>
                                {product._displayInfo?.discountPrice !=
                                  null && (
                                  <div className="pricing-row floor-price-row">
                                    <span className="pricing-label">
                                      Max Discount Floor:
                                    </span>
                                    <span className="pricing-value floor">
                                      ₹
                                      {product._displayInfo.discountPrice.toFixed(
                                        2,
                                      )}
                                      <span className="floor-hint">
                                        (lowest offer)
                                      </span>
                                    </span>
                                  </div>
                                )}
                              </div>

                              <div className="cart-item-quantity">
                                <label>Quantity:</label>
                                <div className="quantity-controls">
                                  <button
                                    type="button"
                                    className="quantity-btn minus"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      const newQty = product.quantity - 1;
                                      if (newQty > 0)
                                        updateProductQuantity(index, newQty);
                                      else removeProductFromCart(index);
                                    }}
                                  >
                                    -
                                  </button>
                                  <input
                                    type="number"
                                    min="1"
                                    value={product.quantity}
                                    onChange={(e) =>
                                      updateProductQuantity(
                                        index,
                                        e.target.value,
                                      )
                                    }
                                    className="quantity-input"
                                  />
                                  <button
                                    type="button"
                                    className="quantity-btn plus"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      updateProductQuantity(
                                        index,
                                        product.quantity + 1,
                                      );
                                    }}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>

                              {product.customPrice && (
                                <div className="cart-item-custom-price">
                                  <label>Custom Price (₹):</label>
                                  <input
                                    type="number"
                                    min="0"
                                    step="0.01"
                                    value={product.price || 0}
                                    onChange={(e) =>
                                      updateProductPrice(index, e.target.value)
                                    }
                                    className="price-input"
                                    placeholder="Enter custom price"
                                  />
                                </div>
                              )}
                            </div>

                            {/* ── TOPICS & ACTIONS ──────────────────── */}
                            <div className="cart-item-topics">
                              <div className="topics-header">
                                <span className="topics-label">Topics</span>
                                <button
                                  type="button"
                                  className="topics-add-btn"
                                  onClick={() => addTopicToProduct(index)}
                                >
                                  + Add Topic
                                </button>
                              </div>

                              {(product.topicsRequestDTOList || []).map(
                                (topic, topicIndex) => (
                                  <div
                                    key={topic._id || topicIndex}
                                    className="topic-block"
                                  >
                                    <div className="topic-row">
                                      <input
                                        type="text"
                                        className="topic-input"
                                        placeholder="Topic details…"
                                        value={topic.topicDetails}
                                        onChange={(e) =>
                                          updateTopic(
                                            index,
                                            topicIndex,
                                            "topicDetails",
                                            e.target.value,
                                          )
                                        }
                                      />
                                      <button
                                        type="button"
                                        className="topic-remove-btn"
                                        onClick={() =>
                                          removeTopic(index, topicIndex)
                                        }
                                        title="Remove topic"
                                      >
                                        ✕
                                      </button>
                                    </div>

                                    {/* Actions */}
                                    <div className="actions-list">
                                      {(topic.actionsRequestDTOList || []).map(
                                        (action, actionIndex) => (
                                          <div
                                            key={action._id || actionIndex}
                                            className="action-row"
                                          >
                                            <input
                                              type="text"
                                              className="action-input"
                                              placeholder="Action…"
                                              value={action.actions}
                                              onChange={(e) =>
                                                updateAction(
                                                  index,
                                                  topicIndex,
                                                  actionIndex,
                                                  "actions",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                            <select
                                              className="action-status-select"
                                              value={action.status}
                                              onChange={(e) =>
                                                updateAction(
                                                  index,
                                                  topicIndex,
                                                  actionIndex,
                                                  "status",
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              <option value="PLANNED">
                                                Planned
                                              </option>
                                              <option value="IN_PROGRESS">
                                                In Progress
                                              </option>
                                              <option value="COMPLETED">
                                                Completed
                                              </option>
                                              <option value="CANCELLED">
                                                Cancelled
                                              </option>
                                            </select>
                                            <input
                                              type="text"
                                              className="action-remarks-input"
                                              placeholder="Remarks…"
                                              value={action.remarks}
                                              onChange={(e) =>
                                                updateAction(
                                                  index,
                                                  topicIndex,
                                                  actionIndex,
                                                  "remarks",
                                                  e.target.value,
                                                )
                                              }
                                            />
                                            <button
                                              type="button"
                                              className="action-remove-btn"
                                              onClick={() =>
                                                removeAction(
                                                  index,
                                                  topicIndex,
                                                  actionIndex,
                                                )
                                              }
                                              title="Remove action"
                                            >
                                              ✕
                                            </button>
                                          </div>
                                        ),
                                      )}
                                      <button
                                        type="button"
                                        className="action-add-btn"
                                        onClick={() =>
                                          addActionToTopic(index, topicIndex)
                                        }
                                      >
                                        + Add Action
                                      </button>
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>

                            {/* Tax rate — editable if custom pricing, read-only otherwise */}
                            {product.customPrice ? (
                              <div className="cart-item-tax">
                                <label>Tax Rate (%):</label>
                                <input
                                  type="number"
                                  min="0"
                                  step="0.01"
                                  value={product.taxRate ?? 0}
                                  onChange={(e) =>
                                    updateProductTaxRate(index, e.target.value)
                                  }
                                  className="tax-input"
                                  placeholder="e.g. 18"
                                />
                              </div>
                            ) : (
                              <div className="cart-item-tax readonly">
                                <span className="pricing-label">Tax Rate:</span>
                                <span className="pricing-value">
                                  {product._displayInfo?.taxRate ?? 0}%
                                </span>
                              </div>
                            )}

                            {/* Per-product line total with tax breakdown */}
                            {(() => {
                              const unitPrice = product.customPrice
                                ? product.price || 0
                                : product._displayInfo?.sellingPrice || 0;
                              const taxRate = product.customPrice
                                ? (product.taxRate ?? 0)
                                : (product._displayInfo?.taxRate ?? 0);
                              const qty = Number(product.quantity) || 0;
                              const baseAmount = unitPrice * qty;
                              const taxAmount = (baseAmount * taxRate) / 100;
                              const sgst = taxAmount / 2;
                              const cgst = taxAmount / 2;
                              const halfRate = taxRate / 2;
                              const halfRateLabel =
                                halfRate % 1 === 0
                                  ? halfRate.toFixed(0)
                                  : halfRate.toFixed(1);
                              const lineTotal = baseAmount + taxAmount;

                              return (
                                <div className="cart-item-subtotal">
                                  <div className="subtotal-breakdown">
                                    <span className="subtotal-formula">
                                      ₹{unitPrice.toFixed(2)} × {qty}
                                    </span>
                                    <strong className="subtotal-amount">
                                      ₹{baseAmount.toFixed(2)}
                                    </strong>
                                  </div>
                                  {taxRate > 0 && (
                                    <>
                                      <div className="subtotal-tax-line">
                                        <span>SGST ({halfRateLabel}%)</span>
                                        <span>₹{sgst.toFixed(2)}</span>
                                      </div>
                                      <div className="subtotal-tax-line">
                                        <span>CGST ({halfRateLabel}%)</span>
                                        <span>₹{cgst.toFixed(2)}</span>
                                      </div>
                                    </>
                                  )}
                                  <div className="subtotal-total-line">
                                    <span>Line Total:</span>
                                    <strong>₹{lineTotal.toFixed(2)}</strong>
                                  </div>
                                </div>
                              );
                            })()}
                          </div>
                        ))}
                        <div className="cart-summary">
                          <div className="summary-header">
                            <svg
                              width="15"
                              height="15"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              aria-hidden="true"
                            >
                              <circle cx="9" cy="21" r="1" />
                              <circle cx="20" cy="21" r="1" />
                              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
                            </svg>
                            <span>Order Summary</span>
                          </div>

                          <div className="summary-body">
                            <div className="summary-row">
                              <span>Items</span>
                              <strong>{enquiryForm.products.length}</strong>
                            </div>
                            <div className="summary-row">
                              <span>Total Quantity</span>
                              <strong>
                                {enquiryForm.products.reduce(
                                  (s, p) => s + (Number(p.quantity) || 0),
                                  0,
                                )}{" "}
                                units
                              </strong>
                            </div>
                          </div>

                          {(() => {
                            // Subtotal = sum of (unit price × qty), before tax
                            const subtotal = enquiryForm.products.reduce(
                              (sum, p) => {
                                const price = p.customPrice
                                  ? p.price || 0
                                  : p._displayInfo?.sellingPrice || 0;
                                return sum + price * (Number(p.quantity) || 0);
                              },
                              0,
                            );

                            const discountAmt =
                              enquiryForm.discountPercentage > 0
                                ? subtotal *
                                  (enquiryForm.discountPercentage / 100)
                                : 0;
                            const subtotalAfterDiscount =
                              subtotal - discountAmt;

                            // Group tax amounts by rate across all products
                            const taxByRate = enquiryForm.products.reduce(
                              (acc, p) => {
                                const price = p.customPrice
                                  ? p.price || 0
                                  : p._displayInfo?.sellingPrice || 0;
                                const qty = Number(p.quantity) || 0;
                                const rate = p.customPrice
                                  ? (p.taxRate ?? 0)
                                  : (p._displayInfo?.taxRate ?? 0);
                                if (rate > 0) {
                                  acc[rate] =
                                    (acc[rate] || 0) +
                                    (price * qty * rate) / 100;
                                }
                                return acc;
                              },
                              {},
                            );

                            const totalTax = Object.values(taxByRate).reduce(
                              (s, v) => s + v,
                              0,
                            );
                            const grandTotal = subtotalAfterDiscount + totalTax;

                            return (
                              <>
                                <div className="summary-divider" />

                                <div className="summary-row">
                                  <span>Subtotal</span>
                                  <strong>₹{subtotal.toFixed(2)}</strong>
                                </div>

                                {discountAmt > 0 && (
                                  <div className="summary-row red">
                                    <span>
                                      Discount ({enquiryForm.discountPercentage}
                                      %)
                                    </span>
                                    <strong>−₹{discountAmt.toFixed(2)}</strong>
                                  </div>
                                )}

                                {/* SGST + CGST split per tax rate */}
                                {Object.entries(taxByRate).map(
                                  ([rate, taxAmt]) => {
                                    const half = taxAmt / 2;
                                    const halfRate = Number(rate) / 2;
                                    const halfRateLabel =
                                      halfRate % 1 === 0
                                        ? halfRate.toFixed(0)
                                        : halfRate.toFixed(1);
                                    return (
                                      <React.Fragment key={rate}>
                                        <div className="summary-row">
                                          <span>SGST ({halfRateLabel}%)</span>
                                          <strong>₹{half.toFixed(2)}</strong>
                                        </div>
                                        <div className="summary-row">
                                          <span>CGST ({halfRateLabel}%)</span>
                                          <strong>₹{half.toFixed(2)}</strong>
                                        </div>
                                      </React.Fragment>
                                    );
                                  },
                                )}

                                <div className="summary-divider" />

                                <div className="summary-total">
                                  <span>Grand Total</span>
                                  <strong>₹{grandTotal.toFixed(2)}</strong>
                                </div>
                              </>
                            );
                          })()}
                        </div>
                        <div className="cart-export-row"></div>
                      </div>
                    ) : (
                      <div className="cart-empty">
                        <p className="help-text">
                          No products selected yet. Add products from the
                          catalog above.
                        </p>
                      </div>
                    )}
                  </div>
  );
};

export default SelectedProductsCart;
